// Core
import React from 'react';
import { render } from 'react-dom';

// Instruments
import './theme/init';

// App
import App from './pages/App';

render(<App />, document.getElementById('app'));
